export default {
  en: {
    Title: "Grade Control",
    Grade : 'Grade',
    Cutoff : 'Capping',
    ExtractionDate : 'Extraction Date',
    ExtractionDateShort : "Extraction",
    Contractual : 'Contractual',
    Shift : 'Shift',
    MuckTypeShort : 'Size',
    BucketCount : 'Buckets',
    Miner : "Miner",
    Actual: "Actual",
    Total: "Total",
    Density : "Density",
    DensityUnitMetric : "(ton/m3)",
    DensityUnitImperial : "(short ton/ft3)",
    CappingUnit: "(g/T)",
    CappingUnitImperial: "(oz/T)",
    Tonnage: "Tonnage",
    TonnageUnitMetric: "(Tonnes)",
    TonnageUnitImperial: "(Tons)",
    Volume : 'Volume',
    VolumeUnitMetric : '(m3)',
    VolumeUnitImperial : '(ft3)',
    AverageGrades : "Average grades",
    MLViews: {
      Importation : "Meliadine views",
      InProgress : "Meliadine views Exportation is in progress",
      Success : "Meliadine views Exportation completed successfully",
      Failure : "Meliadine views Exportation has failed",
      ConfirmImport : "Do you really want to trigger the Meliadine views Exportation?"
    },
    Timesheet: {
      Title: "Timesheets",
      DateSelection : 'Select a date',
      TimesheetList : 'Timesheets',
      BucketCount : 'Buckets',
      Tonnage : "Tonnage",
      SampleStart : 'Starting sample',
      SampleEnd : 'Ending sample',
      LocationType : 'Location type',
      Destination : 'Destination',
      DestinationCannotBeSameAsLocation : 'The destination cannot be the same as the location.',
      RockType : 'Rocktype',
      MaterialType : 'Material Type',
      BlastType : 'Blast Type',
      BlastDate : 'Blast Date',
      BlastDateShort : 'Blast',
      RoundNumber : 'Round/Blast Number',
      IsAutomation : 'Automated',
      Employee : 'Employee',
      TimesheetOperationType : 'Operation',
      Source : 'Source',
      TimesheetDeleted : "The selected timesheet was successfully deleted",
      ConfirmImport: "Do you really want to import the selected timesheets?",
      TooManySample: "Some timesheet have more than 50 samples defined.  Do you still want to import the selected timesheets?",
      ImportCompleted: "Timesheets have been successfully imported",
      ConfirmCancelImport: "Do you really want to cancel importation of the selected timesheet?",
      CancelImportCompleted: "Timesheet importation have been successfully cancelled",
      ConfirmCancelImportBatch: "Do you really want to cancel importation of the selected timesheets?",
      CancelImportCompletedBatch: "Timesheets importation have been successfully cancelled",
      NoTimesheetSelected: "No timesheet selected",
      AddNew: "Add new timesheet",
      Edit : "Update timesheet",
      SampleStartShort : 'Starting',
      SampleEndShort : 'Ending',
      SampleCountShort : 'Count',
      SampleRanges : "Samples",
      OverridePrefix : 'Override sample prefix',
      SamplePrefix : "Sample prefix",
      Step1 : "Base",
      SampleCount : "Sample count",
      ConfirmDelete : "Do you really want to delete this timesheet?",
      ConfirmDeleteMultiple :  "Do you really want to delete the selected timesheets?",
      ConfirmDuplicate : "Do you really want to duplicate this timesheet?",
      ConfirmRestore : "Do you really want to restore this timesheet?",
      RestoreCompleted : "Timesheet has been successfully restored",
      AddNewLocation: "Create a new location",
      Importation: {
        ResultTitle: "Importation results"
      },
      ShowDeleted : 'Display deleted timesheets',
      Versions: "Versions",
      VersionEventType : {
        '0' : "Created",
        '1' : "Modified",
        '2' : "Deleted",
        '3' : "Restored",
        '4' : "Approved"
      },
      VersionProperties: {
        BlastDate: 'Blast Date'
      },
      VersionList: "Version list",
      VersionChanged: "Version modification",
      VersionComment: "Comment",
      VersionOldValue: "Old value",
      VersionNewValue: "New value",
      VersionUpdateComplete: "Timesheet version have been successfully updated",
      Comments: "Comments",
      OperationComments: "Operation comments",
      UserComments: "User comments",
      OverrideDensity: "Override",
      Density: "Density",
      LocationForecastDensity: "Location density",
      ModificationDate: "Modification date",
      ApprovalDate: "Approval date",
      EquipmentRequired: "Equipment required",
      EquipmentRequiredMessage: "You must select an equipment before entering a tonnage"
    },
    Forecast: {
      Title: "Forecasts",
      Name: "Forecast",
      AddNew: "Add new forecast",
      Edit : "Update forecast",
      ForecastList : 'Location Forecast',
      ForecastDeleted : "The selected forecast was successfully deleted",
      ConfirmDelete : "Do you really want to delete this forecast?",
      ConfirmDuplicate : "Do you really want to duplicate this forecast?",
      CancelApprobation : "Cancel approbation",
      ConfirmCancelApprobation : "Do you really want to unapprove this forecast?",
      ConfirmCancelBatchApprobation : "Do you really want to unapprove these forecasts?",
      Tonnage : "Tonnage",
      Statistics : "Statistics",
      NoForecastSelected : "No forecast selected",
      ApprobationCompleted: "Selected forecasts have been successfully approved",
      CancellationCompleted: "Selected forecasts have been successfully disapproved",
      ConfirmApprobation :  "Do you really want to approve the selected forecasts?",
      CopyNextMonth : "Transpose",
      ConfirmCopyNextMonth : "Do you really want to copy the selected forecasts to next month?",
      CopyNextMonthCompleted : "Selected forecasts have been successfully copied to next month",
      ConfirmDeleteMultiple :  "Do you really want to delete the selected forecasts?",
      Step1 : "Base",
      Step2 : "Elements",
      UploadFile : "Upload forecast file",
      UploadInvalidFileError : "Invalid upload file",
      UploadSuccess : "The forecast file has been successfully uploaded",
      UploadFails : "Upload failure",
      UploadFailText : "The upload file has an unsupported schema.  Please download the latest available template and try again",
      TemplateFile : 'Get the forecast upload template file',
      SelectMonth : "Select the month"
    },
    ProductionSummary: {
      Title: "Production Summary",
      LongTitle: "Production summary per location",
      GradePerPeriod : "Grade / Tonnage Evolution",
      GoldProduction : "Au Ounces",
      Sample: "Samples",
      ReceivedSamples: "Received",
      TotalSamples: "Total"
    },
    MonthlySummary: {
      Title: "Monthly Summary",
      ForecastTonnage : "Forecasted Tonnage",
      ActualTonnage : "Actual Tonnage",
      LocationFollowup: "Location Follow-up",
      GradeDistribution: "Grade distribution",
      ImportCompleted: "Timesheets have been successfully imported",
      ConfirmCancelImport: "Do you really want to cancel importation of the selected timesheet?"
    },
    Posting: {
      Title: "Month Closing",
      LocationList : "Posted Location List",
      ConfirmPost: "Do you really want to post the selected locations?",
      PostCompleted: "Selected locations have been successfully posted",
      NoForecastSelected:  "No location selected",
      ConfirmText: "Please confirm the posting operation",
      ConfirmCancelPosting: "Do you really want to cancel posting of the selected location?",
      CancelPostingCompleted: "Location posting have been successfully cancelled",
      NoPostedLocationSelected: "No posted location selected",
      ConfirmCancelPostingBatch: "Do you really want to cancel posting of the selected locations?",
      CancelPostingCompletedBatch: "Locations posting have been successfully cancelled"
    },
    Muck: {
      MuckDeleted : "The selected muck was successfully deleted",
      MuckList : "Muck List",
      HaulingList : "Hauling List",
      ConfirmDelete : "Do you really want to delete this muck?",
      AddNew : "Add New Muck",
      Edit : "Update Muck",
      ApprovedBy: "Approved By",
      ApprovalDateTime: "Approval Date",
      ReceivedSampleRate: "Received Sample Rate"
    },
    Sample: {
      Title: 'Sample',
      SampleMeasures : 'Sample Measures',
      LIMSTitle: 'Sample Importation',
      Code: "Code",
      ReceivedDate: 'Received Date',
      CertifiedDate : 'Certified Date',
      Received : 'Received',
      Certified : 'Certified',
      IncludedSamples : 'Included Samples',
      ExcludedSamples : 'Excluded Samples',
      IncludedLocationSampleResults : "Included approved sample results",
      ExcludedLocationSampleResults : "Excluded approved sample results",
      IncludedSampleMeasure : "Included sample measure",
      ExcludedSampleMeasure : "Excluded sample measure",
      AutoExcludedSampleMeasure : "Automatically excluded sample measure",
      SampleDeleted : "The selected sample was successfully deleted",
      SampleList : "Sample List",
      ConfirmDelete : "Do you really want to delete this sample?",
      ConfirmExclusion : "Do you really want to exclude this sample?",
      SampleExcluded : "The selected sample was successfully excluded",
      ConfirmInclusion : "Do you really want to include this sample?",
      SampleGoldGrade : "Sample gold grades",
      SampleReceivedRate : "Received (%)",
      SampleReceivedAuRate : "Received Au (%)",
      SampleReceivedBaseRate : "Received Base (%)",
      SampleNumber : "Code",
      Certificate : "Certificate",
      NoSampleSelected : "No sample selected",
      ConfirmImport: "Do you really want to import the selected samples?",
      ConfirmSingleImport: "Do you really want to import this sample?",
      ConfirmCancelImport: "Do you really want to cancel importation of the selected sample?",
      ImportCompleted: "Samples have been successfully imported",
      ConfirmCancelImportBatch: "Do you really want to cancel importation of the selected samples?",
      CancelImportCompletedBatch: "Samples importation have been successfully cancelled",
      CancelImportCompleted : "Sample importation have been successfully cancelled",
      OnlyWarnings : "Only decisions to take",
      ImportedNoExclusion : 'Imported w/o exclusion',
      ImportedWithExclusion : 'Imported with exclusions',
      Orphan : 'Orphans',
      NotImported : 'Not Imported',
      MonthlyStats : 'Monthly stats',
      QCType : "QC Type",
      OnlyNonApprouved : 'Display all non imported samples',
      Importation: {
        ResultTitle: "Importation results"
      }
    },
    Employee: {
      Title : 'Employees',
      AddNew: "Add new employee",
      Edit : "Update employee",
      Name: "Employee",
      Code: "Employee Number",
      FirstName : "First name",
      LastName : "Last name",
      IsActive: "Active",
      ConfirmDelete : "Do you really want to delete the employee {code}?",
      EmployeeDeleted: "The selected employee was successfully deleted"
    },
    Location: {
      Title : 'Locations',
      AddNew: "Add new location",
      Edit : "Update location",
      Name: "Location",
      Code: "Code",
      Type : "Location Type",
      Capping : "Capping",
      AlternateCodes : "Alternate codes (separated by semicolon)",
      AlternateCodesShort: "Alternate Codes",
      IsActive: "Active",
      OnlyActive: "Only active",
      GoldGradeStatistics : "Gold Grade statistics",
      ConfirmDelete : "Do you really want to delete the location {code}?",
      LocationDeleted: "The selected location was successfully deleted"
    },
    MuckType: {
      ModelName : 'Muck type',
      Title : 'Muck types',
      Name : 'Name',
      Code : 'Code',
      Factor : 'Factor',
      Comments : 'Comments',
      AddNew : "Add new muck type",
      Edit : "Update muck type",
      ConfirmDelete : "Do you really want to delete this muck type {code}?",
      LocationDeleted: "The selected muck type was successfully deleted"
    },
    MaterialSubType: {
      ModelName : 'Material sub type',
      Title : 'Material sub types',
      Name : 'Name',
      Code : 'Code',
      IsActive: "Active",
      OnlyActive: "Only active",
      AddNew : "Add new material sub type",
      Edit : "Update material sub type",
      ConfirmDelete : "Do you really want to delete this material sub type {code}?",
      MaterialSubTypeDeleted: "The selected material sub type was successfully deleted"
    },
    Equipment: {
      Title : 'Equipments',
      Name : 'Equipment',
      Code : 'Code',
      Company: 'Company',
      Type: 'Type',
      Description : 'Description',
      Volume : 'Volume',
      AddNew : "Add new equipment",
      Edit : "Update equipment",
      IsActive: "Active",
      OnlyActive: "Only active",
      ConfirmDelete : "Do you really want to delete this equipment {code}?",
      EquipmentDeleted: "The selected equipment was successfully deleted"
    },
    EquipmentType: {
      '0': 'Scoop',
      '1': 'Truck'
    },
    Reports: {
      Title: "Reports",
      Dashboard : "Dashboard",
      Timesheet : "Timesheet ",
      Stockpile : "Stock Pile",
      Muck : "Muck",
      Annual : "Annual",
      Monthly : "Monthly",
      Periodic : "Periodic",
      DailyMonitoring : "Daily Monitoring",
      LocationSummary : "Location Summary",
      ProductionSummary : "Progression Table",
      PostingSummary : "Posting Summary",
      Summary : "Summary",
      SummaryOtherMaterial : "Summary (Other Material)",
      SummaryLive : "Summary (Live)",
      Forecast : "Forecast",
      SampleStats : "Sample Statistics",
      LabStats : "Lab Statistics",
      SampleAnomalies : "Sampling anomalies",
      SampleSummary : "Sample summary",
      SampleTracking : "Samples tracking",
      DailyLocationStats : "Daily Location Muck Stats",
      LocationSummaryStats : "Location Summary Muck Stats",
      Goldex : "Goldex Reports",
      Odyssey : "Odyssey Reports",
      Detour : "Detour Reports",
      DeswikExport : "Deswik Export"
    },
    Admin: {
      Title : "Admin"
    },
    TimesheetOperationType:{
      '0': 'Muck',
      '1': 'Rehandling',
      '2': 'Hauling'
    },
    Destinations: {
      Title: "Destinations"
    },
    Destination: {
      AddNew: "Add new",
      Edit: "Edit",
      Name: "Name",
      Type: "Type",
      ConfirmDelete: "Are you sure you want to delete the destination?",
      DestinationDeleted: "The destination has been deleted."
    },
    BlastType: {
      '0': "Round",
      '1': "Slash",
      '2': "Bench",
      '3': "Backslash round"
    },
    DestinationType: {
      '1': "Remuck Bay",
      '2': "Ore Pass",
      '3': "Truck",
      '4': "Stock Pile"
    },
    RemuckForecast: {
      Title: "Monthly rehandling density",
      Edit: "Edit monthly rehandling density",
      Density : "Density"
    },
    TimesheetsSummary: {
      Title: "Total approved",
      Total: "Total"
    },
    NSRForecast: {
      Title: "NSR",
      Save: "Save NSR forecasts",
      Reserve: "$ Reserve",
      ThreeMonths: "$ 3 months",
      Au: "$ Au",
      Ag: "$ Ag",
      Cu: "$ Cu",
      Zn: "$ Zn",
      Pb: "$ Pb",
      Annual: "Annual",
      Monthly: "Monthly",
      NSRReserve: "NSR Res.",
      NSR3Months: "NSR 3 months",
      LockedBy: "Locked by {user} on {date} at {time}",
      MetalPrice: "Metal prices",
      RecoveryPercentage: "Recovery percentage",
      CurrencyRate: "Currency exchange rate",
      RefineryCostPerTon: "Refinery cost per ton",
      CuAuId: "Cu + Au",
      ZnId: "Zn",
      ZnBelowThreshold: "If Zn < {threshold}%",
      ZnAboveThreshold: "If Zn >= {threshold}%",
      ZnGrade: "Zn grade",
      NSRDisabled: "The NSR management feature is disabled in your organization."
    },
    NSRForecastType: {
      '0': "Reserve",
      '1': "3 months"
    }
  }
}
